import React, { useState } from "react";
import styles from "./Header.module.css";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export default function Header({ query, onQueryChange }) {
    const [open, setOpen] = useState(false);

    const navigate=useNavigate();
    const handleLogout=()=>{
        Cookies.remove("msisdn");
        toast.success("Logged out successfully!");
        navigate("/");
    }
    return (
        <header className={styles.header}>
            <div className={styles.wrap}>
                <div className={styles.logo} aria-label="Kids Portal">
                    <div className={styles.badge}>★</div>
                    <div className={styles.brand}>KidsMania</div>
                </div>
                <div className={styles.search} role="search">
                    <input
                        className={styles.input}
                        placeholder="Search rhymes, ABCs, stories…"
                        value={query}
                        onChange={(e) => onQueryChange(e.target.value)}
                        aria-label="Search videos"
                    />
                    <span className={styles.icon}>🔎</span>
                </div>
                <div className={styles.profile}>
                    <div className={styles.avatar} onClick={() => setOpen(s => !s)} title="Account">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="32"
                            height="32"
                            fill="currentColor"
                            style={{ borderRadius: "50%", padding: "4px" }}
                        >
                            <path d="M12 12c2.7 0 5-2.3 5-5s-2.3-5-5-5-5 2.3-5 5 2.3 5 5 5zm0 2c-3.3 0-10 1.7-10 5v3h20v-3c0-3.3-6.7-5-10-5z" />
                        </svg>
                    </div>
                    <div className={`${styles.menu} ${open ? styles.menuOpen : ''}`}>
                        {/* <button className={styles.menuBtn} onClick={() => alert('Open Profile')}>👤 Profile</button> */}
                        {/* <button className={styles.menuBtn} onClick={() => alert('Settings')}>⚙️ Settings</button> */}
                        {/* <button className={styles.menuBtn} onClick={() => { localStorage.clear(); alert('Cleared local data'); }}>🧹 Clear Local Data</button> */}
                        <button className={styles.menuBtn} onClick={() => handleLogout()}>🚪 Log out</button>
                    </div>
                </div>
            </div>
        </header>
    );
}